import React from 'react';
import PropTypes from 'prop-types';
import { FormattedDate } from 'react-intl';

import { TranslatedCopy } from '../../intl/TranslatedCopy';

import { Button, Currency, P } from '../../components/';

const OpenCartCard = ({
  cart: { departmentName, createdBy, orderType, modifiedAt, totalWholesale, id, departmentNumber },
  idx,
  currencyCode,
  handleOpenCartClick
}) => (
  <div className='orderStatus__card bg-white pt5-sm pb4-sm prl4-sm border-bottom'>
    <div className='text-color-secondary'>
      <P data-desc={`cart_approval__departmentName_${idx}`}>
        <TranslatedCopy id='global.department' />
        {`: ${departmentName}`}
      </P>
      <P data-desc={`cart_approval__createdBy_${idx}`}>
        <TranslatedCopy id='global.createdBy' />
        {`: ${createdBy}`}
      </P>
      <P data-desc={`cart_approval__orderType_${idx}`}>
        <TranslatedCopy id='global.orderType' />
        {`: ${orderType}`}
      </P>
      <P data-desc={`cart_approval__modifiedAt_${idx}`}>
        <TranslatedCopy id='openCarts.dateCreated' />
        {': '}
        <FormattedDate value={modifiedAt} />
      </P>
      <P data-desc={`cart_approval__totalWholesale_${idx}`}>
        <TranslatedCopy id='global.total' />
        {': '}
        <Currency value={totalWholesale || '0'} type={currencyCode} />
      </P>
      <Button
        secondary
        extraClassName='mt3-sm u-full-width'
        data-desc={`cart_approval__shop_${orderType}_${idx}`}
        onClick={e => handleOpenCartClick(id, departmentNumber, orderType, e)}
      >
        <TranslatedCopy id='openCarts.table.cart.link' />
      </Button>
    </div>
  </div>
);

OpenCartCard.propTypes = {
  cart: PropTypes.any.isRequired,
  idx: PropTypes.number.isRequired,
  currencyCode: PropTypes.string.isRequired,
  handleOpenCartClick: PropTypes.func.isRequired
};

export default OpenCartCard;
